import React from "react";

const BaseInnerBlankCardMainText = (props) => {
  return (<p {...props} className={`${props.custom ? props.custom : ""}
                        ${props.extra ? props.extra : ""}`}>
    {props.children}
  </p>);
};

export default BaseInnerBlankCardMainText;